<template>
    <div class="fhv-centent">
        <h4 class="title-topic">System</h4>
        <el-form size="small"  label-position="left" class="fhv-form" label-width="250px" v-loading="loading"
        :disabled="$G_DEVICE_CFG.isReadOnly">
            <el-form-item label="Save Settings To Local Hard Drive :">
                <el-button type="info" @click="save">Save</el-button>
            </el-form-item>
            <el-form-item label="Load Settings From Local Hard Drive :">
                <el-upload
                    ref="upload"
                    action="/boafrm/formUploadConfig"
                    :file-list="fileList"
                    :on-success="updateSuccess"
                    :before-upload="checkFile"
                    accept=".dat"
                    :limit="1"
                    :auto-upload="false">
                    <el-button slot="trigger" size="small" type="info" > Select File</el-button>
                    <el-button  size="small" type="info" @click="submitUpload" style="margin-left:10px;"> Update</el-button>            
                </el-upload>
                 
            </el-form-item>
        </el-form>

    </div>
</template>

<script>
import Reboot from '@/components/reboot'
export default {
    data(){
        return {
            fileList:[],
            loading:false
        }
    },
    methods:{
        save(){
            this.loading = true
            axios
            .post("/JSONAPI",{
                cmdType:"SET_SAVE_SYSTEM_CONFIG"
            })
            .then((response)=>{
                this.loading = false
                if(response.data.ret === 0)
                    window.location.href = '/config.dat'
                else
                     this.$message.error('Save Settings To Local Hard Drive Faild!')
            })
            .catch((error) => {
                this.loading = false
                this.$message.error('Save Settings To Local Hard Drive Faild!')
            })
        },
        submitUpload() {
            this.$refs.upload.submit();
        },
        checkFile(file){
            if(!file.name.match(/.dat/))
            {
                this.$message.error("Wrong file type, please select again!")
                return false
            }  
        },
        updateSuccess(response, file, fileList){
            Reboot.updata(this,"The load settings was uploaded successfully! The device is restarting please wait...")
        },
    }
}
</script>

<style scoped>
.fhv-form{
    width: 100%;
}
</style>



